// src/App.js
import React, { useState } from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Section1 from './components/Section1';
import Section2 from './components/Section2';
import Section3 from './components/Section3';
import Section4 from './components/Section4';
import Section5 from './components/Section5';
import Section6 from './components/Section6';
import Section7 from './components/Section7';
import Section8 from './components/Section8';

// React Router
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AccessibilityStatement from './pages/AccessibilityStatement';

function App() {
  const [highContrast, setHighContrast] = useState(false);

  const toggleContrast = () => {
    setHighContrast(prev => !prev);
  };

  return (
    <>
      {/* Globalny styl */}
      <GlobalStyles
        styles={theme => ({
          html: {
            [theme.breakpoints.down('sm')]: {
              overflowX: 'hidden',         // scroll tylko na body
              height: '100vh',
              width: '100vw',          // żeby body mogło przewijać się całe
            },
          },
         
          '*:not(.MuiButton-root):not(.MuiButton-root *)': {
            backgroundColor: highContrast ? 'black !important' : undefined,
            color: highContrast ? 'white !important' : undefined,
            backgroundImage: highContrast ? 'none !important' : undefined,
          },
          body: {
              overflowX: 'hidden',         // scroll tylko na body
            height: '100vh',
            width: '100%',
            backgroundColor: highContrast ? 'black' : undefined,
            color: highContrast ? 'white' : undefined,
          },
          '.MuiButton-root.MuiButton-contained': {
            backgroundColor: highContrast
              ? `${theme.palette.common.white} !important`
              : undefined,
            color: highContrast
              ? `${theme.palette.common.black} !important`
              : undefined,
            backgroundImage: highContrast ? 'none !important' : undefined,
          },
          '.MuiButton-root.MuiButton-contained:hover, .MuiButton-root.MuiButton-contained:focus, .MuiButton-root.MuiButton-contained:active': {
            backgroundColor: highContrast
              ? `${theme.palette.common.white} !important`
              : undefined,
            color: highContrast
              ? `${theme.palette.common.black} !important`
              : undefined,
            backgroundImage: highContrast ? 'none !important' : undefined,
          },
          '#logo-eu, #logo-eu2':{
             backgroundColor: highContrast
              ? `${theme.palette.common.white} !important`
              : undefined,
          }
        })}
      />

      <Header onToggleContrast={toggleContrast} />

      <Routes>
        {/* Strona główna z wszystkimi sekcjami */}
        <Route
          path="/"
          element={
            <>
              <Section1 />
              <Section2 />
              <Section3 />
              <Section4 />
              {/* sekcja z pakietami zakomentowana */}
              {/* <Section5 /> */}
              {/* sekcja z logotypami zakomentowana */}
              {/* <Section6 /> */}
              <Section7 />
              <Section8 />
            </>
          }
        />

        {/* Podstrony */}
        <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
        <Route path="/deklaracja-dostepnosci" element={<AccessibilityStatement />} />

        {/* Wszelkie inne URL → strona główna */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
      {/* Banner zgody na cookies */}
      <CookieConsent />
    </>
  );
}

export default App;
